<template>
  <modal size="lg" @close="$emit('close')">
    <div class="w-full flex flex-wrap">
      <p
        class="text-center"
      >Input the URL of the Twitch or YouTube video below to add it to your post.</p>
      <div class="w-full mb-2 px-2">
        <nx-input type="url" v-model="url" label="Video URL" id="url" :focus="true" />
      </div>
      <div class="w-full">
        <nx-button
          :disabled="!valid || loading"
          @click="submit"
        >{{ loading ? 'Loading..' : 'Insert' }}</nx-button>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "axios"
import { loadProgressBar } from "axios-progress-bar"

export default {
  name: "RichTextEmbedModal",
  data() {
    return {
      client: null,
      url: "",
      globalPattern: /http[s]?:\/\/clips\.twitch\.tv\/.+|http[s]?:\/\/www\.twitch\.tv\/.+|http[s]?:\/\/twitch\.tv\/.+|https:\/\/.+\.youtube.com\/watch?.+|https:\/\/.+\.youtube.com\/v\/.+|https:\/\/youtu\.be\/.+/i,
      youtubePattern: /https:\/\/.+\.youtube.com\/watch?.+|https:\/\/.+\.youtube.com\/v\/.+|https:\/\/youtu\.be\/.+/i,
      twitchPattern: /http[s]?:\/\/clips\.twitch\.tv\/.+|http[s]?:\/\/www\.twitch\.tv\/.+|http[s]?:\/\/twitch\.tv\/.+/i,
      loading: false
    }
  },
  computed: {
    valid() {
      return this.globalPattern.test(this.url)
    }
  },
  methods: {
    async submit() {
      if (!this.valid) return

      this.loading = true
      await this.axios
        .get(`embed?url=${this.url}`)
        .then(({ data }) => {
          this.$emit("success", data.trim())
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.error();
          } else {
            this.$error.generic()
          }
        })
      this.loading = false
    },
    error() {
      this.url = ""
      this.$toasted.error(
        "Unable to insert this video. Please try a different video."
      )
    }
  },
  mounted() {
    this.client = axios.create()
    loadProgressBar("", this.client)
  }
}
</script>

<style scoped lang="scss">
</style>
